var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"jz-chat-hint",class:[_vm.data.class, _vm.data.staticClass]},[_c('div',{staticClass:"content"},[_c('span',[_vm._v(_vm._s(_vm.props.label))]),_c('span',[_vm._v(" "+_vm._s(_vm.props.hints.join(", "))+" "),_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }